export default {
  BASIC: 'basic',
  OPTIONS: 'options',
  TIME: 'time',
  FILE: 'file',
};
